function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C5.86549 0 3.85758 0.830289 2.34549 2.3412C0.833407 3.85212 0 5.86192 0 8C0 10.1381 0.833407 12.1479 2.34549 13.6588C3.85758 15.1697 5.86198 16 8 16C10.138 16 12.1424 15.1697 13.6545 13.6588C15.1666 12.1479 16 10.1381 16 8C16 5.86192 15.1666 3.85212 13.6545 2.3412C12.1424 0.830289 10.1345 0 8 0ZM8 14.931C4.17055 14.931 1.05495 11.82 1.05495 8C1.05495 4.17996 4.17055 1.06904 8 1.06904C11.8295 1.06904 14.9451 4.17996 14.9451 8C14.9451 11.82 11.8295 14.931 8 14.931Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3889 10.5622L7.80784 7.947V2.78053C7.80784 2.44915 7.5259 2.18164 7.17663 2.18164C6.82735 2.18164 6.54541 2.44915 6.54541 2.78053V8.24245C6.54541 8.4301 6.62957 8.60578 6.78527 8.71757L10.6189 11.5124C10.7325 11.5963 10.8671 11.6362 11.0018 11.6362C11.1912 11.6362 11.3805 11.5563 11.5068 11.4006C11.7172 11.1411 11.6667 10.7658 11.3889 10.5622Z",
  fill: "currentColor"
});

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.64992acc.svg";
export { ForwardRef as ReactComponent };